import React, {Component, PropTypes} from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {autobind} from 'core-decorators';

export default class Entity extends Component {
    static propTypes = {
        entity: ImmutablePropTypes.map.isRequired,
        tabIndex: PropTypes.number,
        onClick: PropTypes.func.isRequired,
    };

    shouldComponentUpdate(nextProps) {
        return nextProps.entity !== this.props.entity
            || nextProps.tabIndex !== this.props.tabIndex
            || nextProps.onClick !== this.props.onClick;
    }

    @autobind
    handleClick() {
        this.props.onClick(this.props.entity);
    }

    render() {
        return (
            <button
                type='button'
                className='cielo24-vwrap-item cielo24-vwrap-entity'
                onClick={this.handleClick}
                tabIndex={this.props.tabIndex}
            >
                <span className='cielo24-vwrap-display'>{this.props.entity.get('displayAs')}</span>
                <span className='cielo24-vwrap-pill'>{this.props.entity.get('count')}</span>
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/entity-menu/entity.js